import React, {ReactNode, useContext, useReducer} from 'react';

import {buildInitialState, ModuleContext, IModuleContextState} from './ModuleContext.ts';
import ModuleReducer from './ModuleReducer.ts';
import {IModuleState} from '@/types/state';

interface IModuleProviderProps<T extends IModuleState> {
    children: ReactNode | ReactNode[];
    defaultState: T
}

function ModuleProvider<T extends IModuleState>({children, defaultState}: IModuleProviderProps<T>) {
    const [{state}, dispatch] = useReducer(ModuleReducer<T>, buildInitialState(defaultState));



    const cleanState = () => {
        dispatch({type: 'cleanState', payload: defaultState});
    };

    const setState = <k extends keyof T = keyof T>(key: k, value: T[k]) => {
        dispatch({type: 'setState', payload: {key, value}});
    };

    return (
        <ModuleContext.Provider value={{
            state,
            defaultState,
            setState,
            cleanState
        }}
        >
            {children}
        </ModuleContext.Provider>
    );
}


export const useModuleContext = <T extends IModuleState>() => {
    const context = useContext<IModuleContextState<T>>(
        (ModuleContext as unknown) as React.Context<IModuleContextState<T>>
    );
    if (!context) {
        throw new Error('useModuleContext must be used under ModuleProvider');
    }

    return context;
}


export default ModuleProvider

